module.exports = __webpack_public_path__ + "1d5652ad338de14a9db9f03e8327ed85.png";